/**
 * When true, the customer (user) app shows the maintenance screen; `/admin/*` and
 * logged-in admin dashboard stay available.
 * Flip to `false` when the storefront should be live again (when env is unset).
 * Build with `REACT_APP_MAINTENANCE_MODE=false` to force the full user app on without editing code.
 */
const DEFAULT_MAINTENANCE = true;

const fromEnv = process.env.REACT_APP_MAINTENANCE_MODE;
const envOff = fromEnv === "false";
const envOn = fromEnv === "true";

export const MAINTENANCE_MODE = envOff
  ? false
  : envOn
    ? true
    : DEFAULT_MAINTENANCE;
